import React from 'react';
import HomepageHero from '../../molecules/homepage-hero/homepage-hero';
import Promos from '../../molecules/promos/promos';
import UniversitySelectBar from '../../molecules/university-select-bar/university-select-bar';
import HomepageViewModel from '../../../models/homepage/HomepageViewModel';
import { ApplicationSettings } from '../../../models/settings';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { ReadonlyURLSearchParams } from 'next/navigation';

type Props = {
  content: HomepageViewModel;
  currentLocale: string;
  router: AppRouterInstance;
  searchParams: ReadonlyURLSearchParams;
  pathname: string;
  applicationSettings: ApplicationSettings;
  applicationURL: string;
};

export default function Homepage({
  content: { universitiesData, promos, homepageHeroData },
  currentLocale,
  router,
  applicationSettings,
  searchParams,
  pathname,
  applicationURL,
}: Props) {
  return (
    <>
      <HomepageHero
        homepageHeroData={homepageHeroData}
        router={router}
        applicationSettings={applicationSettings}
        currentLocale={currentLocale}
        searchParams={searchParams}
        pathname={pathname}
        applicationURL={applicationURL}
      />
      {promos.length ? <Promos content={promos} /> : null}
      {universitiesData.countries.length ? (
        <UniversitySelectBar
          universities={universitiesData.universities}
          countries={universitiesData.countries}
          currentLocale={currentLocale}
          applicationBranding={applicationSettings.branding}
        />
      ) : null}
    </>
  );
}
